export const revenueOperationsGettingStartedArticle = {
  title: 'Revenue Operations Hub: Getting Started',
  slug: 'revenue-operations-getting-started',
  content: `Revenue Operations Hub: Getting Started

Track revenue, spend, and runway in one workspace.

1) Open the finance workspace
- Go to /finance-hub.
- Tabs use URL hashes (#transactions, #dashboard, #insights).

2) Record transactions
- Use Transactions to log revenue and expense activity.

3) Review dashboards
- Dashboard summarizes key revenue and spend metrics.

4) Monitor insights
- Insights highlights trends and anomalies.

Related tools
- Forecasting Hub: /forecasting-hub for break-even and cash flow analysis.
- Pricing Hub: /pricing-hub for calculators and margin analysis.
`,
};
